import { render, staticRenderFns } from "./UnfollowIcon.vue?vue&type=template&id=cb612b3a&"
import script from "./UnfollowIcon.vue?vue&type=script&lang=ts&"
export * from "./UnfollowIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports